import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './POSTAUCT_Auction_Result_Intake.css';

const POSTAUCT_Auction_Result_Intake = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"POSTAUCT_AUCTION_RESULT_INTAKE",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	POSTAUCT_AUCTION_RESULT_INTAKE:-1
  });


  const [POSTAUCT_AUCTION_RESULT_INTAKE, setPOSTAUCT_AUCTION_RESULT_INTAKE] = React.useState(null);
  const [POSTAUCT_AUCTION_RESULT_INTAKE_D, setPOSTAUCT_AUCTION_RESULT_INTAKE_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Post-Auction Result Intake');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/POSTAUCT_Auction_Result_Intake',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewPOSTAUCT_AUCTION_RESULT_INTAKE(clientInfo,"OpenNew");

		navigate('/POSTAUCT_Auction_Result_Intake',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Auction_Result_Intake_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewPOSTAUCT_AUCTION_RESULT_INTAKE(clientInfo,"OpenNew");
		}
		navigate('/POSTAUCT_Auction_Result_Intake',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Auction_Result_Intake_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Auction_Result_Intake_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Auction_Result_Intake_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
		if(Temp_Data2.status!="New"){
			handleDeletePOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data2);
			navigate('/POSTAUCT_Auction_Result_Intake#New',{replace:true});
		} 
		else 
			navigate('/POSTAUCT_Auction_Result_Intake',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Auction_Result_Intake',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Auction_Result_Intake',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Auction_Result_Intake',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Auction_Result_Intake',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!POSTAUCT_AUCTION_RESULT_INTAKE) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_${i}_SECTION`;
	  const headerId = `#POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [POSTAUCT_AUCTION_RESULT_INTAKE]) ;


  
  
  var Ids = [];
  for(var Ele in POSTAUCT_AUCTION_RESULT_INTAKE){
	  for(var Sec in POSTAUCT_AUCTION_RESULT_INTAKE[Ele]){
		if(Sec == "id")
			Ids.push(POSTAUCT_AUCTION_RESULT_INTAKE[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(POSTAUCT_AUCTION_RESULT_INTAKE[Ele]["status"]);
		else if(Array.isArray(POSTAUCT_AUCTION_RESULT_INTAKE[Ele][Sec]))
			  for(var Row in POSTAUCT_AUCTION_RESULT_INTAKE[Ele][Sec])  // Convert to POSTAUCT_AUCTION_RESULT_INTAKE[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in POSTAUCT_AUCTION_RESULT_INTAKE[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["POSTAUCT_AUCTION_RESULT_INTAKE"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewPOSTAUCT_AUCTION_RESULT_INTAKE(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_AUCTION_RESULT_INTAKE`).then((response1) => {
		if(!POSTAUCT_AUCTION_RESULT_INTAKE) 
			setPOSTAUCT_AUCTION_RESULT_INTAKE(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_AUCTION_RESULT_INTAKE_D`).then((response2) => {
			setPOSTAUCT_AUCTION_RESULT_INTAKE_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddPOSTAUCT_AUCTION_RESULT_INTAKE_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewPOSTAUCT_AUCTION_RESULT_INTAKE = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_AUCTION_RESULT_INTAKE/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setPOSTAUCT_AUCTION_RESULT_INTAKE(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_AUCTION_RESULT_INTAKE/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutPOSTAUCT_AUCTION_RESULT_INTAKE = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_AUCTION_RESULT_INTAKE/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostPOSTAUCT_AUCTION_RESULT_INTAKE = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_AUCTION_RESULT_INTAKE', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeletePOSTAUCT_AUCTION_RESULT_INTAKE = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_AUCTION_RESULT_INTAKE', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["1"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_0"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("1","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["1"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_1"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("1","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["1"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_2"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("1","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  

const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["1"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_3"]=value;
	Form_Data_onChange("1","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  

    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["2"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_0"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("2","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["2"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_1"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("2","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["2"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_2"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("2","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["3"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_0"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("3","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
  
      
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["3"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1"]=value ? true : false; // optionally just use boolean
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("3","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  



const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["4"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_4_0"]=value;
	Form_Data_onChange("4","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_4_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  

    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_0"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_1"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_2"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_3"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  

const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_4"]=value;
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_4",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  

    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["5"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_5"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("5","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_5",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
  
      
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0"]=value ? true : false; // optionally just use boolean
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  



const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_1"]=value;
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  


const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_2"]=value;
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  

    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_3"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_4"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_4",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_5"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_5",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_6_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_6"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_6"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_6",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_7_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_7"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_7"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_7",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_8_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_8"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_8"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_8",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  

const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_9_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_9"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_9"]=value;
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_9",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  


const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_10_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_10"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_10"]=value;
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_10",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  


const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_11_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_11"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_11"]=value;
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_11",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  


const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_12_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_12"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_12"]=value;
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_12",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  

    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_13_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_13"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_13"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_13",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_14_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_14"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_14"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_14",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_15_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_15"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_15"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_15",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_16_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_16"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_16"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_16",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_17_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_17"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_17"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_17",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_18_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_18"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_18"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_18",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_19_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_19"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_19"]=value;
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_19",value,Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
  }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_20_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_20"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_20"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_20",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_21_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_21"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["8"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_21"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("8","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_21",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  

const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["9"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_0"]=value;
	Form_Data_onChange("9","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
  }; 
  

    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["9"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_1"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("9","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["9"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_2"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("9","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["9"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_3"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("9","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  
    
const POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
	Temp_Data["9"]["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_4"]=value;
	//handleAddPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data,App_Data['POSTAUCT_AUCTION_RESULT_INTAKE']);
	Form_Data_onChange("9","POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_4",value,Temp_Data);
 	//handleLastDataPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
    setPOSTAUCT_AUCTION_RESULT_INTAKE(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!POSTAUCT_AUCTION_RESULT_INTAKE) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedPOSTAUCT_AUCTION_RESULT_INTAKE =JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
  updatedPOSTAUCT_AUCTION_RESULT_INTAKE[Sec] = [...updatedPOSTAUCT_AUCTION_RESULT_INTAKE[Sec], newRow];
  setPOSTAUCT_AUCTION_RESULT_INTAKE(updatedPOSTAUCT_AUCTION_RESULT_INTAKE);
};

const handleDeleteRow = (sec,index) => {
  const updatedPOSTAUCT_AUCTION_RESULT_INTAKE = JSON.parse(JSON.stringify(POSTAUCT_AUCTION_RESULT_INTAKE));
  updatedPOSTAUCT_AUCTION_RESULT_INTAKE[sec].splice(index, 1);
  setPOSTAUCT_AUCTION_RESULT_INTAKE(updatedPOSTAUCT_AUCTION_RESULT_INTAKE);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Post-Auction Result Intake`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Post-Auction Result Intake ID`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`POSTAUCT Result Intake ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_0" type="text" className="form-control" placeholder="POSTAUCT Result Intake ID" value={POSTAUCT_AUCTION_RESULT_INTAKE["1"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_0`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter POSTAUCT Result Intake ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Auction Result ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_1" type="text" className="form-control" placeholder="PREAUCT Auction Result ID" value={POSTAUCT_AUCTION_RESULT_INTAKE["1"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_1`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Auction Result ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Auction Opportunity ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_2" type="text" className="form-control" placeholder="Auction Opportunity ID" value={POSTAUCT_AUCTION_RESULT_INTAKE["1"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_2`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Auction Opportunity ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Auction Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_3"  value={POSTAUCT_AUCTION_RESULT_INTAKE["1"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_3`]} onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_1_3_Change} className="form-control" name="Auction Type"  >
						  <option value="Foreclosure">Foreclosure</option>
						  <option value="Tax Sale">Tax Sale</option>
						  <option value="Sheriff Sale">Sheriff Sale</option>
						  <option value="Bankruptcy Sale">Bankruptcy Sale</option>
						  <option value="REO Auction">REO Auction</option>
						  <option value="Private Auction">Private Auction</option>
						  <option value="Online Auction">Online Auction</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Auction Type
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Winning Bid USD`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Winning Bid USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_0" type="text" className="form-control" placeholder="Winning Bid USD" value={POSTAUCT_AUCTION_RESULT_INTAKE["2"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_0`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Winning Bid USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Auction Result Date`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_1" type="text" className="form-control" placeholder="Auction Result Date" value={POSTAUCT_AUCTION_RESULT_INTAKE["2"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_1`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Auction Result Date`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '160ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Winning Bidder Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_2" type="text" className="form-control" placeholder="Winning Bidder Name" value={POSTAUCT_AUCTION_RESULT_INTAKE["2"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_2`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '160ch' }}>
						 {t(`Enter Winning Bidder Name`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Auction Result Document Link`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Auction Result Document Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_0" type="text" className="form-control" placeholder="Auction Result Document Link" value={POSTAUCT_AUCTION_RESULT_INTAKE["3"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_0`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Auction Result Document Link`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Result Verified`)} <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1_Change} 
					  checked={POSTAUCT_AUCTION_RESULT_INTAKE?.["3"]?.["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1"] === "true" || POSTAUCT_AUCTION_RESULT_INTAKE?.["3"]?.["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_3_1"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Intake Status`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Intake Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_4_0"  value={POSTAUCT_AUCTION_RESULT_INTAKE["4"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_4_0`]} onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_4_0_Change} className="form-control" name="Intake Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="In Progress">In Progress</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Completed">Completed</option>
						  <option value="Cancelled">Cancelled</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Intake Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_0" type="text" className="form-control" placeholder="Submitted By" value={POSTAUCT_AUCTION_RESULT_INTAKE["5"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_0`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_1" type="text" className="form-control" placeholder="Submitted At" value={POSTAUCT_AUCTION_RESULT_INTAKE["5"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_1`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_2" type="text" className="form-control" placeholder="Reviewed By" value={POSTAUCT_AUCTION_RESULT_INTAKE["5"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_2`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_3" type="text" className="form-control" placeholder="Reviewed At" value={POSTAUCT_AUCTION_RESULT_INTAKE["5"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_3`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_4"  value={POSTAUCT_AUCTION_RESULT_INTAKE["5"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_4`]} onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_5" type="text" className="form-control" placeholder="Approval Notes" value={POSTAUCT_AUCTION_RESULT_INTAKE["5"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_5`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Map Display Enabled`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Map Display Enabled`)} <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0_Change} 
					  checked={POSTAUCT_AUCTION_RESULT_INTAKE?.["8"]?.["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0"] === "true" || POSTAUCT_AUCTION_RESULT_INTAKE?.["8"]?.["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_0"] === true} />
					</label>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Map Public Visibility`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_1"  value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_1`]} onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_1_Change} className="form-control" name="Map Public Visibility"  >
						  <option value="Exact Public Boundary">Exact Public Boundary</option>
						  <option value="Approximate Public Boundary">Approximate Public Boundary</option>
						  <option value="Hidden From Public">Hidden From Public</option>
						  <option value="Investor Only After Login">Investor Only After Login</option>
						  <option value="Accredited / Approved Investor Only">Accredited / Approved Investor Only</option>
						  <option value="Internal Only">Internal Only</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Map Public Visibility
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Map Listing Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_2"  value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_2`]} onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_2_Change} className="form-control" name="Map Listing Status"  >
						  <option value="Not Listed">Not Listed</option>
						  <option value="Pre-Listing Draft">Pre-Listing Draft</option>
						  <option value="Preview Only">Preview Only</option>
						  <option value="Listed - Not Investable">Listed - Not Investable</option>
						  <option value="Listed - Investment Open">Listed - Investment Open</option>
						  <option value="Paused">Paused</option>
						  <option value="Closed">Closed</option>
						  <option value="Archived">Archived</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Map Listing Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Google Map Place ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_3" type="text" className="form-control" placeholder="Google Map Place ID" value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_3`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_3_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter Google Map Place ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Google Maps URL`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_4" type="text" className="form-control" placeholder="Google Maps URL" value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_4`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_4_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Google Maps URL`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '240ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Display Address`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_5" type="text" className="form-control" placeholder="Map Display Address" value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_5`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_5_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '240ch' }}>
						 {t(`Enter Map Display Address`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Center Latitude`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_6" type="text" className="form-control" placeholder="Map Center Latitude" value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_6`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_6_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_6"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Map Center Latitude`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Center Longitude`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_7" type="text" className="form-control" placeholder="Map Center Longitude" value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_7`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_7_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_7"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Map Center Longitude`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Default Zoom`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_8" type="text" className="form-control" placeholder="Map Default Zoom" value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_8`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_8_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_8"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Map Default Zoom`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_9"  value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_9`]} onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_9_Change} className="form-control" name="Boundary Type"  >
						  <option value="Point Only">Point Only</option>
						  <option value="Parcel Boundary">Parcel Boundary</option>
						  <option value="Building Footprint">Building Footprint</option>
						  <option value="Unit Boundary">Unit Boundary</option>
						  <option value="Multi-Parcel Boundary">Multi-Parcel Boundary</option>
						  <option value="Multi-Building Boundary">Multi-Building Boundary</option>
						  <option value="Development Site Boundary">Development Site Boundary</option>
						  <option value="Easement / Access Boundary">Easement / Access Boundary</option>
						  <option value="Estimated Boundary">Estimated Boundary</option>
						  <option value="Confidential Boundary">Confidential Boundary</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Type
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Source`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_10"  value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_10`]} onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_10_Change} className="form-control" name="Boundary Source"  >
						  <option value="Google Maps">Google Maps</option>
						  <option value="Manual Pin">Manual Pin</option>
						  <option value="County GIS Parcel">County GIS Parcel</option>
						  <option value="Assessor Parcel Map">Assessor Parcel Map</option>
						  <option value="Survey">Survey</option>
						  <option value="Title Report">Title Report</option>
						  <option value="Deed Legal Description">Deed Legal Description</option>
						  <option value="KML / KMZ Upload">KML / KMZ Upload</option>
						  <option value="GeoJSON Upload">GeoJSON Upload</option>
						  <option value="Broker / Seller Provided">Broker / Seller Provided</option>
						  <option value="Auction Source">Auction Source</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Source
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Verification Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_11"  value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_11`]} onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_11_Change} className="form-control" name="Boundary Verification Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Unverified">Unverified</option>
						  <option value="Auto-Geocoded">Auto-Geocoded</option>
						  <option value="Manually Drawn">Manually Drawn</option>
						  <option value="Needs Review">Needs Review</option>
						  <option value="Verified by Platform">Verified by Platform</option>
						  <option value="Verified by Survey">Verified by Survey</option>
						  <option value="Verified by Title / County Record">Verified by Title / County Record</option>
						  <option value="Disputed">Disputed</option>
						  <option value="Hidden / Confidential">Hidden / Confidential</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Verification Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Geometry Format`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_12"  value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_12`]} onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_12_Change} className="form-control" name="Boundary Geometry Format"  >
						  <option value="Point">Point</option>
						  <option value="Bounding Box">Bounding Box</option>
						  <option value="Polygon GeoJSON">Polygon GeoJSON</option>
						  <option value="MultiPolygon GeoJSON">MultiPolygon GeoJSON</option>
						  <option value="FeatureCollection GeoJSON">FeatureCollection GeoJSON</option>
						  <option value="WKT">WKT</option>
						  <option value="KML / KMZ">KML / KMZ</option>
						  <option value="Encoded Polyline">Encoded Polyline</option>
						  <option value="Image Overlay Reference">Image Overlay Reference</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Geometry Format
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '12000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary GeoJSON`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_13" type="text" className="form-control" placeholder="Boundary GeoJSON" value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_13`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_13_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_13"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '12000ch' }}>
						 {t(`Enter Boundary GeoJSON`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '12000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary WKT`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_14" type="text" className="form-control" placeholder="Boundary WKT" value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_14`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_14_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_14"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '12000ch' }}>
						 {t(`Enter Boundary WKT`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '500ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary Bounding Box`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_15" type="text" className="form-control" placeholder="Boundary Bounding Box" value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_15`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_15_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_15"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '500ch' }}>
						 {t(`Enter Boundary Bounding Box`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Parcel ID List`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_16" type="text" className="form-control" placeholder="Parcel ID List" value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_16`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_16_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_16"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Parcel ID List`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Legal Description Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_17" type="text" className="form-control" placeholder="Legal Description Link" value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_17`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_17_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_17"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Legal Description Link`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Survey Document Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_18" type="text" className="form-control" placeholder="Survey Document Link" value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_18`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_18_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_18"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Survey Document Link`)}
                     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Boundary Last Verified Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_19" type="date"  value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_19`]} 
							onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_19_Change} style={{ borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_19"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Boundary Last Verified Date
					  </div>
				  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '80ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary Verified By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_20" type="text" className="form-control" placeholder="Boundary Verified By" value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_20`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_20_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_20"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '80ch' }}>
						 {t(`Enter Boundary Verified By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '1000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Disclaimer`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_21" type="text" className="form-control" placeholder="Map Disclaimer" value={POSTAUCT_AUCTION_RESULT_INTAKE["8"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_21`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_21_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_8_21"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '1000ch' }}>
						 {t(`Enter Map Disclaimer`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_0"  value={POSTAUCT_AUCTION_RESULT_INTAKE["9"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_0`]} onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_1" type="text" className="form-control" placeholder="Created By" value={POSTAUCT_AUCTION_RESULT_INTAKE["9"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_1`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_2" type="text" className="form-control" placeholder="Created At" value={POSTAUCT_AUCTION_RESULT_INTAKE["9"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_2`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_3" type="text" className="form-control" placeholder="Updated By" value={POSTAUCT_AUCTION_RESULT_INTAKE["9"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_3`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_4" type="text" className="form-control" placeholder="Updated At" value={POSTAUCT_AUCTION_RESULT_INTAKE["9"][`POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_4`]} 
						onChange={POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_01_SPONSOR_AUCTION_RESULT_INTAKE_CLOSING_POSTAUCT_AUCTION_RESULT_INTAKE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default POSTAUCT_Auction_Result_Intake;  